<base-customer-dashboard-unpublished-inquiries-list-headline></base-customer-dashboard-unpublished-inquiries-list-headline>
<base-customer-dashboard-unpublished-inquiries-list-item
  *ngFor="let inquiry of unpublishedInquiries | slice: 0:5; let i = index; trackBy: trackByInquiry"
  [inquiry]="inquiry"
  [canPublishInquiry]="canPublishInquiry"
  [state]="states[i]"
  (selectInquiryAction)="handleClick($event, inquiry.id)"
></base-customer-dashboard-unpublished-inquiries-list-item>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>
